"use client";

import { useEffect, useState } from "react";

// Мобильный брейкпоинт (как в остальных компонентах — max-width 900px).
export function useIsMobile(max = 900): boolean {
  const [m, setM] = useState(false);
  useEffect(() => {
    const mq = window.matchMedia(`(max-width: ${max}px)`);
    const on = () => setM(mq.matches);
    on();
    mq.addEventListener("change", on);
    return () => mq.removeEventListener("change", on);
  }, [max]);
  return m;
}
